const canUse = () => typeof document !== 'undefined'

export default canUse
